<template>

      <section class="space-sm">

        <div class="container align-self-start">

          <div class="row justify-content-center">

            <div class="col-12 col-md-8 col-lg-7">

              <div class="card card-lg mt-3 border-0">

                <div class="card-body bg-black border-0">

                  <div class="my-5 text-center">
                    <h1 class="h2 mb-2 font-weight-light text-white">Email Verification</h1>
                  </div>
                
                  <div class="row no-gutters justify-content-center">

                    <div v-if="success" class="form-group text-center">
                        <h4 :class="message_class + ' font-weight-light'">{{title}}</h4>
                        <p :class="message_class + ' font-weight-light'">{{ message }}</p> <br>
                        <a class="btn btn-lg btn-outline-light mx-auto " href="trackdDeeplink://">Open App</a>
                    </div>

                    <div v-if="error" class="form-group text-center">
                        <h4 :class="message_class + ' font-weight-light'">{{title}}</h4>
                        <p :class="message_class + ' font-weight-light'">{{ message }}</p> <br>
                        <a class="btn btn-lg btn-outline-light mx-auto " href="trackdDeeplink://">Open App</a>
                    </div>

                    <b-spinner v-if="!success && !error" class="text-light" label="Loading..."></b-spinner>

                  </div>
                  <!--end of row-->
                </div>
              </div>
            </div>
            <!--end of col-->
          </div>
          <!--end of row-->
        </div>
      <!--end of section-->
      </section>
      
</template>

<script>
  import axios from "axios";

  export default {
    data () {
      return {
          title: '',
          message_class: 'text-white',
          message: '',
          success: false,
          error: false
      }
    },
    created(){
      
      if (this.$route.params.token) {
        const formData = {
          token: this.$route.params.token
        }
        
        axios.put('/users/email-verification-confirm/', formData).then(
          response => {
            
            console.log(response)

            if (response.status ===  201) {

              this.success = true;

              this.title = "Thanks for verifying"
              this.message_class = "text-success"
              this.message = "We hope you enjoy the app."
            
            } else if (response.status === 200) {

              this.success = true;

              this.title = "Thanks"
              this.message_class = "text-success"
              this.message = "Your email address has already been confirmed."

            }
          }
        ).catch(error => {

          this.error = true;

          this.title = "Hmmm..."
          this.message_class = "text-danger"
          this.message = error.response.data.errors[0];

      
        })
      }
    },
    methods: {
    }
  }
</script>

<style>
</style>